// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { NavPanelComponent } from './nav-panel/nav-panel.component';
import { BackButtonComponent } from './back-button/back-button.component';
import { ProjectColumnComponent } from './project-column/project-column.component';
import { AddressFieldComponent } from './address-field/address-field.component';
import { MembershipTierComponent } from './membership-tier/membership-tier.component';
import { AlertBarComponent } from './alert-bar/alert-bar.component';
import { SafePipe } from '@app/shared/safe.pipe';
import { LogoUploadComponent } from './logo-upload/logo-upload.component';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { ErrorStateComponent } from './error-state/error-state.component';
import { DataTableFooterComponent } from './data-table/data-table-footer/data-table-footer.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { DataTableFilterComponent } from './data-table/data-table-filter/data-table-filter.component';
import { DataTableAjaxComponent } from './data-table-ajax/data-table-ajax.component';
import { InputValidatorDirective } from '@app/core/directives/input-validator.directive';
import { DescriptionValidatorDirective } from '@app/core/directives/description-validator.directive';
import { InputTextComponent } from './input-text/input-text.component';
import { AllowedRolesDirective } from '@app/core/directives/allowed-roles.directive';
import { LoadAfterUserDirective } from '@app/core/directives/load-after-user.directive';
import { AuthComponent } from './auth-page/auth-page.component';
import { UserInfoComponent } from './user-info/user-info.component';
import { ClickOutsideDirective } from '@app/core/directives/click-outside.directive';

/**
 * SharedModule is where all DumbComponents should live.
 */
@NgModule({
  imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule, NgSelectModule, NgxDatatableModule],
  declarations: [
    AuthComponent,
    NavPanelComponent,
    BackButtonComponent,
    ProjectColumnComponent,
    AddressFieldComponent,
    MembershipTierComponent,
    SafePipe,
    LogoUploadComponent,
    AlertBarComponent,
    LoadingSpinnerComponent,
    ErrorStateComponent,
    DataTableFooterComponent,
    DataTableFilterComponent,
    DataTableAjaxComponent,
    InputValidatorDirective,
    DescriptionValidatorDirective,
    InputTextComponent,
    AllowedRolesDirective,
    LoadAfterUserDirective,
    UserInfoComponent,
    ClickOutsideDirective
  ],
  exports: [
    AuthComponent,
    NavPanelComponent,
    BackButtonComponent,
    ProjectColumnComponent,
    AddressFieldComponent,
    MembershipTierComponent,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    SafePipe,
    AlertBarComponent,
    LogoUploadComponent,
    LoadingSpinnerComponent,
    ErrorStateComponent,
    DataTableFooterComponent,
    DataTableFilterComponent,
    DataTableAjaxComponent,
    InputValidatorDirective,
    DescriptionValidatorDirective,
    InputTextComponent,
    AllowedRolesDirective,
    LoadAfterUserDirective,
    UserInfoComponent,
    ClickOutsideDirective
  ]
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts